import entityNames from 'options/entityNames'
import { createChildListPrintComponent } from 'factories/ChildListPrint'
import { tableCellComponents } from 'helpers/listItems'

export default createChildListPrintComponent({
  entityName: entityNames.requisitions,
  childName: 'requisitionItems',
  getStorageKey: (self) => 'requisitions.formView.items.pickList',
  tableCellComponents,
})()
